import {ajax} from '../utils/ajaxHelper';
import {log} from '../api/logger';

function getUserData(useMockLogin) {
    const url =
        useMockLogin && useMockLogin.useMockLogin === true
            ? '/pdp/userData?useMockLogin=true'
            : '/pdp/userData';

    return ajax(url)
        .then((response) => response)

        .catch((error) => {
            const errorMessage =
                (error && (error.response && error.response.body)) || error.message;
            log({
                error: `getUserData exception.  Error: ${errorMessage}`
            });
        });
}

export default getUserData;
export {getUserData};
